import * as adjustmentListActions from './adjustmentList/actions';
import * as createEditAdjustmentActions from './createEditAdjustment/actions';

export const actions = {
  ...adjustmentListActions,
  ...createEditAdjustmentActions,
};



// WEBPACK FOOTER //
// ./src/pages/inventory/transaction/adjustment/state/actions.js